import { Box, Button, FormHelperText, IconButton, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import CancelIcon from '@mui/icons-material/Cancel';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useFileUpload } from 'shared/hooks/use-file-upload';

type ContractFormFileUploadFieldProps = {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  accept: string;
  isMultiple?: boolean;
  rules?: Object;
  error?: boolean;
  helperText?: string;
};

export function ContractFormFileUploadField({
  name,
  accept,
  isMultiple,
  rules,
  error,
  helperText,
}: ContractFormFileUploadFieldProps) {
  const {
    handleRemoveFile,
    handleChange,
    files,
    handleDragOver,
    handleDrop,
    handleDragEnter,
    trigger,
    inputRef,
  } = useFileUpload();
  const { setValue, setError } = useFormContext();

  const { field } = useController({
    name,
    rules,
  });

  useEffect(() => {
    field.onChange(files);
  }, [setValue, files, field]);

  useEffect(() => {
    if (!!files?.length) {
      setError('files', { message: 'Contract File is required' });
    }
  }, [files?.length, setError]);

  const hasFiles = !!files?.length;

  return (
    <>
      <input
        id={name}
        ref={inputRef}
        hidden
        type={'file'}
        multiple={!!isMultiple}
        accept={accept}
        onChange={handleChange}
      />
      {(!hasFiles || isMultiple) && (
        <div onDragOver={handleDragOver} onDrop={handleDrop} onDragEnter={handleDragEnter}>
          <Button onClick={trigger} startIcon={<FileUploadIcon />}>
            {`Select File${isMultiple ? '(s)' : ''}`}
          </Button>
          {error && <FormHelperText error={error}>{helperText}</FormHelperText>}
        </div>
      )}
      {!!files && hasFiles && (
        <>
          {files.map(file => (
            <Box display='flex' alignItems='center' key={file.name}>
              <Box>
                <Typography>{file.name}</Typography>
              </Box>
              <Box sx={{ paddingLeft: 1 }}>
                <IconButton title='Remove file' onClick={() => handleRemoveFile(file)}>
                  <CancelIcon />
                </IconButton>
              </Box>
            </Box>
          ))}
        </>
      )}
    </>
  );
}
